import CreateLearningJourney from "src/components/createLearningJourney";

export default function CreateLearningJourneyPage() {
  return (
    <div className='w-11/12 max-w-7xl mx-auto'>
      <CreateLearningJourney />
    </div>
  );
}
